import * as React from 'react'

import { Modal, ModalBody, ModalHeader } from 'reactstrap'

import { File } from '../lib/interfaces/File.interface'

import { formatFileName } from '../lib/helpers/format'
import { getFileExtension, imageFileExtensions } from '../utils/files'

const includes = require('lodash/includes')

export interface FileViewerModalProps {
  open: boolean
  file?: File
  onToggle: () => void
  fetchFile: (fileKey: string, next: (err?: any, downloadedFile?: any) => void) => void
}

export interface FileViewerModalState {
  error?: any
  fileUrl?: string
  isLoading: boolean
}

class FileViewerModal extends React.PureComponent<FileViewerModalProps> {
  state = {
    error: undefined,
    isLoading: false,
    fileUrl: undefined
  }

  componentDidUpdate(prevProps) {
    const { file, open } = this.props
    const { file: prevFile } = prevProps

    if (open && !prevFile && file) {
      this.onFetchFile()
    }
    else if (prevProps.open && !open) {
      this.setState({ fileUrl: undefined })
    }
  }

  onFetchFile() {
    const { file, fetchFile } = this.props

    if (file) {
      this.setState({ error: undefined, isLoading: true })

      fetchFile(file.key, (error, data) => {
        if (!error) {
          this.setState({ error, fileUrl: data.fileURL, isLoading: false })
        }
      })
    }
  }

  get fileExtension() {
    const { file } = this.props
    return getFileExtension(file)
  }

  get fileType() {
    const fileExtension = this.fileExtension

    if (this.isImage) {
      return `image/${fileExtension}`
    }

    if (fileExtension === 'pdf') {
      return 'application/pdf'
    }

    if (includes(['mov', 'mp4'], fileExtension)) {
      return `video/${fileExtension}`
    }

    return undefined
  }

  get isImage() {
    return includes(imageFileExtensions, this.fileExtension)
  }

  render() {
    const { file, open, onToggle } = this.props
    const { error, isLoading, fileUrl } = this.state

    return (
      <Modal
        size="lg"
        id="filemodal"
        isOpen={open}
        toggle={onToggle}
      >
        <ModalHeader toggle={onToggle}>{formatFileName(file)}</ModalHeader>

        <ModalBody>
          <div className="position-relative w-100 h-100">
            {fileUrl &&
              (this.isImage
                ? <div className="h-100 w-100" style={{ backgroundImage: `url(${fileUrl})`, backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} />
                : <embed src={fileUrl} type={this.fileType} width="100%" height="100%" />
              )
            }
            {isLoading &&
              <div className="content-overlay -loading">
                <i className="fas fa-spinner fa-spin" />
              </div>
            }
            {error &&
              <div className="content-overlay">
                <span>
                  There was an error downloading the file
                </span>
                <button className="btn btn-primary mt-3" onClick={() => this.onFetchFile()}>Try again</button>
              </div>
            }
          </div>
        </ModalBody>
      </Modal>
    )
  }
}

export default FileViewerModal



// WEBPACK FOOTER //
// ./src/common/FileViewer.modal.tsx